export default __webpack_public_path__ + "static/media/March2010.f8d7ea93.png";